import React, { ReactNode, useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { LoopyMark } from '../loopy';
import './AuthBootstrapGate.css';

interface AuthBootstrapGateProps {
  children: ReactNode;
}

const AuthBootstrapGate: React.FC<AuthBootstrapGateProps> = ({ children }) => {
  const { isLoading } = useAuth();
  const [bootstrapped, setBootstrapped] = useState(false);

  useEffect(() => {
    if (!isLoading) setBootstrapped(true);
  }, [isLoading]);

  if (bootstrapped) {
    return <>{children}</>;
  }

  return (
    <div className="auth-bootstrap-splash" role="status" aria-live="polite" aria-label="Loading">
      <div className="auth-bootstrap-splash__inner">
        <LoopyMark size={48} />
        <span className="auth-bootstrap-splash__spinner" aria-hidden="true" />
      </div>
    </div>
  );
};

export default AuthBootstrapGate;
